import { createSvgIcon } from "@mui/material";

export const ArrowNextIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.75 11.7246L4.75 11.7246" stroke="#149C84" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.7002 5.701L19.7502 11.725L13.7002 17.75" stroke="#149C84" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  "ArrowNextIcon"
)